module.exports = __webpack_public_path__ + "img/profit-and-cash-flow.68c6ccad.svg";